import { fontSize, size } from '@styles/theme'
import styled from '@emotion/styled/macro'
import useDialog from '@hooks/useDialog'

import NearbyLegendDialog from '@components/nearby/NearbyLegendDialog'
import { PiMapTrifold } from 'react-icons/pi'

const LegendButton = styled.button`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  font-size: ${fontSize('sm')};
  font-weight: bold;
  background-color: rgba(255,255,255,0.1);
  border-radius: 100px;
  padding: ${size(1.5)} ${size(2)};
`

const MapLegendButton = () => {
  const [isLegendDialogOpen, openLegendDialog, closeLegendDialog] = useDialog('settings_nearby_legend', 'settings-nearby-legend-open')

  return (
    <>
      <NearbyLegendDialog
        isOpen={isLegendDialogOpen}
        setClosed={closeLegendDialog}
      />
      <LegendButton
        onClick={() => openLegendDialog()}>
        <PiMapTrifold strokeWidth={size(1)} />
        &nbsp;Map Legend
      </LegendButton>
    </>
  )
}

export { MapLegendButton }
